import React, { useState } from 'react';
import { Layout, Button, Modal, theme } from 'antd';
import cn from "classnames";

import { logoutAction } from 'store/auth/auth.actions';
import {useAppDispatch} from 'store';
import {ReactComponent as Logo} from './logo.svg';
import SidebarMenu from './SidebarMenu';
import styles from './Layout.module.scss';

const {Header, Sider, Content} = Layout;


interface LayoutProps {
  children?: React.ReactNode;
}

const AppLayout: React.FC<LayoutProps> = ({children}: LayoutProps) => {
  const { token } = theme.useToken()
  const [modal, contextHolder] = Modal.useModal();
  const [collapsed, setCollapsed] = useState(true)
  const dispatch = useAppDispatch();
  const handleLogout = () => {
    modal.confirm({
      title: 'Вы хотите выйти?',
      okText: 'Да',
      cancelText: 'Нет',
      maskClosable: true,
      onOk: () => dispatch(logoutAction())
    })
  }
  return (
    <Layout className={styles.layout}>
      <Header className={styles.header} style={{ backgroundColor: token.colorBgBase }}>
        <Logo className={cn(styles.logo, {[styles.collapsed]: collapsed})} />
        <Button onClick={handleLogout}>
          Выйти
        </Button>
      </Header>
      <Layout hasSider={true}>
        <Sider
          theme="light"
          width={270}
          collapsible
          onCollapse={setCollapsed}
          defaultCollapsed={true}
        >
          <SidebarMenu />
        </Sider>
        <Content className={styles.content}>
          {children}
        </Content>
      </Layout>
      {contextHolder}
    </Layout>
  );
};

export default AppLayout;